import React from "react";
import DefaultConsumerLayout from '../../../../components/layout/DefaultConsumerLayout';import AsyncPage from "./async";

export default [
  <DefaultConsumerLayout
    key="/consumer/features/remove-people-from-photo"
    exact
    path="/consumer/features/remove-people-from-photo"
    component={AsyncPage}
  />,
];